import { getStore } from '~/mobx/AppStore';

export const submitDeleteRegions = async (): Promise<void> => {
    const { regionStore, adminStore } = getStore();
    const checkedIds = regionStore.checkedRegionIds;
    // If there are no checked regions, exit early
    if (checkedIds?.length == 0) {
        return;
    }

    regionStore.setIsDeletingRegions(true);

    try {
        await regionStore.deleteRegions(checkedIds);

        // Refresh the regions after deletion
        const electionId = adminStore.election?.id || '';
        await regionStore.fetchRegions(electionId);

        // Clear the checked region IDs
        regionStore.setCheckedRegionIds([]);
    } finally {
        regionStore.setIsDeletingRegions(false);
    }
};
